import Hero from "../components/Home/Hero";
import Contact from "../components/Home/Contact";
import WhyChooseUs from "../components/Home/WhyChooseUs";
import CoreValuesServices from "../components/Home/CoreValuesServices";

export default function Home() {
  return (
    <div id="top">
      <section id="hero">
        <Hero />
      </section>
      <section id="why-choose-us">
        <WhyChooseUs />
      </section>
      <section id="services">
        <CoreValuesServices />
      </section>
      <section id="contact">
        <Contact />
      </section>
    </div>
  );
}
